// src/components/carousel/videoCarouselFAQInstaller.ts

import {
    INSTALLER,
    INSTALLER_ADMIN,
    INSTALLER_APPROVED,
} from "../../../constants/roles"

export interface IUserFlags {
    groups: string[]
    isSignedIn: boolean
    isInstallerUnapproved: boolean
    isDnoApproved: boolean
}

export interface IVideo {
    id: string
    title: string
}

export const INSTALLER_VIDEOS: IVideo[] = [
    { id: "yxFc5zm1WaM", title: "Sign-up - Auto Enrolment" },
    { id: "7MW7ccEYTYI", title: "Sign-up - Join an Existing Team" },
    { id: "E8LeQ1lnyVE", title: "Installer View Application" },
    { id: "JlZIK5kpYVg", title: "Comissioning Appplication" },
    { id: "-jEtx4CQT40", title: "How to Raise a Ticket" },
]

export const getInstallerFaqVideoIds = (): string[] =>
    INSTALLER_VIDEOS.map((v) => v.id)

export const getInstallerCarousel = (
    userFlags: IUserFlags
): {
    videos: IVideo[]
    shouldShow: boolean
} => {
    const { groups, isSignedIn, isInstallerUnapproved } = userFlags

    const isInstallerUser = [
        INSTALLER,
        INSTALLER_ADMIN,
        INSTALLER_APPROVED,
    ].some((role) => groups.includes(role))

    const shouldShow = isSignedIn && !isInstallerUnapproved && isInstallerUser

    return {
        videos: INSTALLER_VIDEOS,
        shouldShow,
    }
}
